import { toast } from "react-toastify";

export const saveItemToWatchlist = (e, id) => {
  e.preventDefault();
  e.stopPropagation();
  
  let watchlist = JSON.parse(localStorage.getItem("watchlist")) || [];
  const coinName = id.substring(0, 1).toUpperCase() + id.substring(1);

  if (watchlist.includes(id)) {
    toast.warning(`⭐ ${coinName} is already in your watchlist!`, {
      position: "bottom-right",
      autoClose: 3000,
    });
    return false;
  }

  watchlist.push(id);
  localStorage.setItem("watchlist", JSON.stringify(watchlist));
  toast.success(`✅ ${coinName} added to watchlist successfully!`, {
    position: "bottom-right",
    autoClose: 3000,
  });
  return true;
};